// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Kuuo","footer":"ModalUpdate_footer__1p2UI"};